// extracted by mini-css-extract-plugin
export default {"answer":"Answer_answer__17TCh","checkboxInput":"Answer_checkboxInput__XLFZk"};